/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { productSchema } from "./productSchema.ts";

export const productsRecommendationListPathOrgUnitIdSchema = z.uuid();

export const productsRecommendationListPathProductIdSchema = z.uuid();

export const productsRecommendationListStatus200Schema = z.array(productSchema);

export const productsRecommendationListStatus404Schema = z.any();

export const productsRecommendationListResponseSchema = z.union([productsRecommendationListStatus200Schema, productsRecommendationListStatus404Schema]);
